import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import article1 from "../../assets/images/new-article/article1.png"
import article2 from "../../assets/images/new-article/article2.png"
import article3 from "../../assets/images/new-article/article3.png"
import "./newArticle.css"

const NewArticle = () => {
  return (
    <section className='new-article text-center'>
      <Container fluid className='custom-container'>
        <div className='heading-sec'>
          <h2 className='h2'>What’s New</h2>
        </div>
        <Row>
          <Col lg={4}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article1} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-type mb-3 position-relative'>
                  {/* <span>Doppatas</span> */}
                  <h4 className='h4 mb-0'>Doppatas</h4>
                </div>
                <span className='shop-now'>
                  Shop Now
                </span>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article2} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-type mb-3 position-relative'>
                  {/* <span>Maxi</span> */}
                  <h4 className='h4 mb-0'>Maxi</h4>
                </div>
                <span className='shop-now'>
                  Shop Now
                </span>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div className='card-wrapper text-white position-relative'>
              <div className='card-img'>
                <Image src={article3} alt="doppatas img" fluid />
              </div>
              <div className='card-body'>
                <div className='product-type mb-3 position-relative'>
                  {/* <span>New Arrival</span> */}
                  <h4 className='h4 mb-0'>New Arrival</h4>
                </div>
                <span className='shop-now'>
                  Shop Now
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default NewArticle